import { update } from "../actions";

const updateTodo = (text, todoId) => {
  return async (dispatch) => {
    const response = await fetch(
      `https://lwsumit.herokuapp.com/todos/${todoId}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          text: text,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8 ",
        },
      }
    );
    const todo = await response.json();
    dispatch(update(todo.id, text));
  };
};

export default updateTodo;
